import { render } from "./SuccessMsg.vue?vue&type=template&id=99c3ac6c"
import script from "./SuccessMsg.vue?vue&type=script&lang=js"
export * from "./SuccessMsg.vue?vue&type=script&lang=js"

import "./SuccessMsg.vue?vue&type=style&index=0&id=99c3ac6c&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__